module.exports = __webpack_public_path__ + "static/media/7You_Logo.469fc635.svg";